<template>
  <div class="rex-breadcrumb-wrapper">
    <Breadcrumb :routes="routes" separator=">">
      <template #itemRender="{ route, routes }">
        <span class="rex-breadcrumb-last" v-if="checkLast(routes, route)">
          {{ route.breadcrumbName }}
        </span>
        <span @click="goTo(route)" v-else>
          {{ route.breadcrumbName }}
        </span>
      </template>
    </Breadcrumb>
  </div>
</template>

<script>
import { Breadcrumb } from 'ant-design-vue';

export default {
  components: {
    Breadcrumb,
  },
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goTo(item) {
      this.$router.push({
        name: item.name,
      });
      this.$emit('onClickEvent', item);
    },
    checkLast(routes, route) {
      return routes.indexOf(route) === routes.length - 1;
    },
  },
};
</script>

<style scoped lang="scss">
.rex-breadcrumb-wrapper {
  height: 4rem;
  display: flex;
  margin-top: 1rem;
  padding-top: 0.6rem;
}
.rex-breadcrumb-last {
  color: $color-brand-accent;
  cursor: default;
}
:deep(.ant-dropdown-trigger) {
  color: $font-primary;
}

:deep(.ant-dropdown-trigger) {
  display: inline-flex;
  align-items: center;
  color: $font-light-gray;
}

:deep(.ant-breadcrumb-separator) {
  padding: 0.5rem;
  color: $font-primary !important;
}

:deep(.ant-breadcrumb) {
  font-size: 1.2rem;
}

:deep(.ant-breadcrumb-link) {
  color: $font-primary;
  cursor: pointer;
}

:deep(.ant-breadcrumb .ant-breadcrumb-overlay-link:hover) {
  background-color: rgb(45, 48, 50);
}

:deep(.ant-breadcrumb-overlay-link) {
  width: 15rem;
}
</style>
